/** תפיסת beforeinstallprompt מוקדם — לפני mount של React */
import { markPwaInstalledLocally } from "./pwaInstall.js";

let deferredPrompt = null;
const listeners = new Set();

export function initPwaInstallCapture() {
  if (typeof window === "undefined" || window.__pwaInstallCaptureInit) return;
  window.__pwaInstallCaptureInit = true;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(e));
  });

  window.addEventListener("appinstalled", () => {
    markPwaInstalledLocally();
    deferredPrompt = null;
    listeners.forEach((fn) => fn(null));
  });
}

export function getDeferredPwaPrompt() {
  return deferredPrompt;
}

export function setDeferredPwaPrompt(value) {
  deferredPrompt = value;
}

export function subscribeDeferredPwaPrompt(listener) {
  listeners.add(listener);
  if (deferredPrompt) listener(deferredPrompt);
  return () => listeners.delete(listener);
}
